import Vue from "vue";
import Config from "@/config";
import {sortByActivity, sortByAuth} from "@/utils/group";
import {initPicksInArea, initFavoriteUsersInArea} from "@/utils/area";
import {iso2Date} from "@/utils/date";
import {nick} from "@/utils/user";
import {findPs} from "@/utils/p";
import {obtainClientId} from "@/utils/auth";
import {applyAreaUpdateFromPayload, applyIsArchivedForGroup, applyUserUpdateFromPayload, appendUserPickFromPayload, removeUserPickFromPayload} from "@/utils/task";

const mutations = {
    userResetClient: (state, payload) => {
        console.log("MUTATION userResetClient", payload);

        state.clientAuth = obtainClientId(true);
    },

    userSession: (state, payload) => {
        console.log("MUTATION userSession", payload);
        //if (!payload) return;

        if ( payload?.isFromServer ) {
            if (  typeof payload?.user !== "object" ) return;

            //console.log("USERS");
            //console.log("users: ", payload.area.users?.map(el=>el.id));

            // apply user
            //state.session.user = payload.user;

            // 2. apply area
            //state.session.area.groups = payload.area.groups;
            applyAreaUpdateFromPayload(state, payload);

            const user = payload.user;
            state.session.isAnon = user?.id === Config.ANONYMOUS_USER_ID;
            //console.log("USER IS ANON: ", user?.auth === Config.ANONYMOUS_USER_AUTH);

            //state.session.currentTask = payload.currentTask;

            // ims
            //state.session.ims = payload.

            state.session.isInited = true;
        }
    },

    userLogout: (state, payload) => {
        console.log("MUTATION userLogout", payload);

        // this does the magic
        mutations.userResetClient(state, payload);

        state.ui.isSessionClosing = true;
        setTimeout(()=> {
            state.session.user = null;
            state.session.workspace = null;
            state.session.area.groups = null;
            state.session.area.picks = null;
            state.session.area.groups = null;
            state.session.area.users = null;
            state.session.area.onlineUsers = null;
            state.session.isAnon = false;
            state.session.currentTask.item = null;
            state.session.oneTask.item = null;
            state.session.isInited = false;


            state.page.task.item = null;
            state.page.task.isInited = false;
            state.page.context.item = null;
            state.page.context.isInited = false;
            state.page.tasks.items = null;
            state.page.tasks.isInited = false;
            state.page.isInited = false;

            state.ui.isSessionClosing = false;
        },1500);
    },

    userMerge: (state, payload) => {
        console.log("MUTATION userMerge", payload);

    },

    userDisconnectIM: (state, payload) => {
        console.log("MUTATION userDisconnectIM", payload);
    },

    userUpdate: (state, payload) => {
        console.log("MUTATION userUpdate", payload);

        if ( payload?.isFromServer ) {
            applyUserUpdateFromPayload(state, payload);
        }
    },

    userGroupSort: (state, payload) => {
        console.log("MUTATION user/groupSort", payload);
        const user = state.session.user;
        if (!user) return;

        const groups = state.session.area.groups;
        if (!groups) return;

        sortByAuth(groups, payload.groupSort, "id");
        //console.log("AFTER sort", group.children.map(c=>c.auth));

        user.groupSort = payload.groupSort;
    },

    userPickSort: (state, payload) => {
        console.log("MUTATION user/pickSort", payload);

        const user = state.session.user;
        if (!user) return;

        const items = state.session.area.picks;
        if (!items) return;

        sortByAuth(items, payload.pickSort, "contextId");

        user.pickSort = payload.pickSort;
    },

    userOnline: (state, payload) => {
        console.log("MUTATION userOnline", payload);
        if (!payload) return;
        if (!state.session.area?.users) return;  // session is not yet fetched

        const onlineUsers = state.session.area.onlineUsers;
        const exists = onlineUsers?.find(el => el.id === payload.userAuth);
        if (!exists) {
            const user = state.session.area.users.find(el => el.id === payload.userAuth);
            if (user) onlineUsers.push(user);
        }
    },

    userOffline: (state, payload) => {
        console.log("MUTATION userOffline", payload);
        if (!payload) return;
        if (!state.session.area?.users) return;  // session is not yet fetched

        const onlineUsers = state.session.area.onlineUsers;
        const index = onlineUsers?.findIndex(el => el.id === payload.userAuth);
        if (index >= 0) onlineUsers.splice(index, 1);
    },

    userFavoriteToggle: (state, payload) => {
        console.log("MUTATION userFavoriteToggle", payload);
        if (payload?.isFromServer) {
            appendUserPickFromPayload(state, payload);
            removeUserPickFromPayload(state, payload);
        }
    },

    userFavUserSort: (state, payload) => {
        console.log("MUTATION user/favUserSort", payload);

        const user = state.session.user;
        if (!user) return;

        // apply to users
        const users = state.session.area.favoriteUsers;
        if (users?.length) {
            sortByAuth(users, payload.favUserSort, "contextId");
        }

        // apply to user
        Vue.set(user, "favUserSort", user.favUserSort);
    },

    userUser: (state, payload) => {
        console.log("MUTATION user/user", payload);

        if (!payload?.updatedUser?.id) return;

        const auth = payload.updatedUser.id;

        const update = (item) => {
            Object.keys(payload.updatedUser).forEach(key => {
                Vue.set(item, key, payload.updatedUser[key]);
            })
        }

        // update current item
        const user = state.session.area.users?.find(el => el.id === auth);
        //console.log("USER FOUND", user);
        if (user) update(user);
        if (state.page.context.assignee) update(state.page.context.assignee);
    },
};

export default mutations;
